export default __webpack_public_path__ + "media/src/assets/images/right-arrow-bb75cc17ccf8da009e88f2848a26ae30.png";